import { PartnerWizard } from './PartnerWizard';

export function FormPartner() {
  return <PartnerWizard />;
}
